module.exports = __webpack_public_path__ + "img/121.675bcba9.jpg";